import React from 'react';
import { aboutService } from '../../services/aboutService';

export default class FeatureFive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            intro: null,
            milestones: []
        };
    }

    async componentDidMount() {
        try {
            const res = await aboutService.getAboutContent();
            if (res.success && res.data) {
                this.setState({
                    intro: res.data.sections ? res.data.sections.history_intro : null,
                    milestones: res.data.milestones && res.data.milestones.length > 0 ? res.data.milestones : this.getFallbackMilestones()
                }, () => {
                    this.initTabsAndCarousel();
                });
            } else {
                this.setState({ milestones: this.getFallbackMilestones() }, () => {
                    this.initTabsAndCarousel();
                });
            }
        } catch (err) {
            console.error('Failed to load about history:', err);
            this.setState({ milestones: this.getFallbackMilestones() }, () => {
                this.initTabsAndCarousel();
            });
        }
    }

    getFallbackMilestones() { return []; }

    initTabsAndCarousel() {
        const $ = window.$;
        if (!$) return;

        if ($(".tabs-box").length) {
            $(".tabs-box .tab-buttons .tab-btn").off("click").on("click", function (e) {
                e.preventDefault();
                var target = $($(this).attr("data-tab"));

                if ($(target).is(":visible")) {
                    return false;
                } else {
                    target
                        .parents(".tabs-box")
                        .find(".tab-buttons")
                        .find(".tab-btn")
                        .removeClass("active-btn");
                    $(this).addClass("active-btn");
                    target
                        .parents(".tabs-box")
                        .find(".tabs-content")
                        .find(".tab")
                        .fadeOut(0);
                    target
                        .parents(".tabs-box")
                        .find(".tabs-content")
                        .find(".tab")
                        .removeClass("active-tab");
                    $(target).fadeIn(300);
                    $(target).addClass("active-tab");
                }
            });
        }

        if ($(".feature-three__history-carousel").length) {
            $(".feature-three__history-carousel").trigger('destroy.owl.carousel');
            $(".feature-three__history-carousel").owlCarousel({
                loop: false,
                margin: 30,
                nav: false,
                smartSpeed: 500,
                autoHeight: false,
                autoplay: true,
                dots: false,
                autoplayTimeout: 6000,
                navText: [
                    '<i className="fa fa-angle-double-left" aria-hidden="true"></i>',
                    '<i className="fa fa-angle-double-right" aria-hidden="true"></i>',
                ],
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    992: { items: 2 },
                    1200: { items: 3 },
                    1350: { items: 3 },
                },
            });
        }
    }

    render() {
        const { intro, milestones } = this.state;
        if(!intro && !milestones.length)return null;
        let publicUrl = process.env.PUBLIC_URL + '/';

        const tagline = intro && intro.tagline ? intro.tagline : '';
        const title = intro && intro.title ? intro.title : '';
        const description = intro && intro.description ? intro.description : '';

        return (
            <>
                <section className="feature-three-sec clearfix">
                    <div className="feature-three__bg" style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/backgrounds/features-v1-bg.jpg)' }}>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="feature-three__title">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>{tagline}</h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title" dangerouslySetInnerHTML={{ __html: title }} />
                                        <p className="sec-title__text">{description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-12">
                                <div className="feature-three__tab tabs-box">
                                    <div className="feature-three__tab-button">
                                        <h3>Our History</h3>
                                    </div>

                                    <div className="tabs-content">
                                        {/* Start Tab */}
                                        <div className="tab active-tab" id="history">
                                            <div className="feature-three__tab-content-item">
                                                <div className="feature-three__history-carousel owl-carousel owl-theme">
                                                    {milestones.map((item, index) => (
                                                        <div className="feature-three__history-single" key={item.id || index}>
                                                            <h5 className='pb-3'>{item.title}</h5>
                                                            <div className="history-text">
                                                                <h2>history</h2>
                                                            </div>
                                                            <div className="date-box">
                                                                <h2>{item.year}</h2>
                                                            </div>
                                                            <p>{item.text}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Tab */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}